// extracted by mini-css-extract-plugin
var _1 = "StartTestModal__bannerText--yE0qU CoreGeneral__roboto--UlmjE";
var _2 = "StartTestModal__illustration--YFgkr";
var _3 = "StartTestModal__illustrationWrap--ZAYH2";
export { _1 as "bannerText", _2 as "illustration", _3 as "illustrationWrap" }
